<template>
  <el-dialog title="新增类目"
             :visible.sync="dialogVisible"
             width="992px"
             :before-close="handleClose">
    <div class="main scroll-auto">
      <span>请选择类目：</span>
      <el-cascader collapse-tags
                   style="width: 480px"
                   filterable
                   clearable
                   :props="{ value: 'id', label: 'name', expandTrigger: 'hover', multiple: true }"
                   v-model="category"
                   :options="category_options"
                   @change="selectListFunc"></el-cascader>
      <p></p>
      <div class="subtitle">
        <h4>经营类目</h4>
      </div>
      <div class="table">
        <el-table :data="CategoryData"
                  style="width: 100%"
                  border
                  :span-method="cellMerge">
          <el-table-column align="center"
                           prop="one"
                           label="一级类目"> </el-table-column>
          <el-table-column align="center"
                           prop="two"
                           label="二级类目"> </el-table-column>
          <el-table-column align="center"
                           prop="three"
                           label="三级类目"> </el-table-column>
          <el-table-column align="center"
                           label="操作">
            <template slot-scope="{ row }">
              <el-link @click="deleteItem(row)"
                       type="primary">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="subtitle">
        <h4>所需资质</h4>
      </div>
      <div class="table">
        <el-table :data="talentList"
                  style="width: 100%"
                  border
                  v-loading="categoryLoad">
          <el-table-column prop="name"
                           label="资质列表">
            <template slot-scope="{ row }">
              <p>类目：{{ row.category_name }}</p>
              <p style="font-size: 14px; color: #666; margin: 8px 0">{{ row.name }}</p>
              <p style="font-size: 14px; color: red; margin: 8px 0"
                 :style="row.is_must == 1 ? 'color: red' : 'color: blue'">
                <span v-if="row.is_must == 1">必选资质 </span>
                <span v-if="row.is_must == 0">选填资质 </span>
              </p>
              <el-upload action="#"
                         :auto-upload="false"
                         :file-list="row.file"
                         :limit="1"
                         :show-file-list="true"
                         :on-preview="(file) => handlePreview(file, 1, row.url)"
                         :on-change="(file, fileList) => handleChange(file, fileList, 1, row.talent_id)"
                         :on-remove="(file, fileList) => handleRemove(file, fileList, 1, row.talent_id)">
                <el-button size="small"
                           type="primary">点击上传</el-button>
              </el-upload>
            </template>
          </el-table-column>
          <el-table-column prop="explain"
                           label="详细说明">
            <template slot-scope="{ row }">
              {{ row.explain || "-" }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary"
                 @click="onSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data () {
    return {
      dialogVisible: false,
      CategoryData: [],
      talentList: [],
      selectList: [],
      ids: "",
      categoryLoad: false,
      category_options: [],
      category: [],
      shop_id: "",
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
  created () {
    this.getCategoryList();
  },
  methods: {
    ...mapActions({
      uploadFile: "commodity/uploadFile", //  图片上传
      getGoodLei: "commodity/getGoodLei", //商品分类
      categoryManges: "detect/categoryManges", 
      categoryAdd: "detect/categoryAdd", //类别价格-说明
    }),
    onSubmit () {
    
      this.btnload = true;
      let talent_all = [];

      this.talentList.forEach((item) => {
        let obj = {
          is_must: item.is_must,
          category_id: item.three_id,
          talent_id: item.talent_id,
          image: item.url,
        };
        talent_all.push(obj);
      });
      let flag = true
      if (talent_all.length > 0) {
         flag = talent_all.some(item => {
          return item.is_must == 1 && item.image !== '' 
        })
        if (flag) {
          let params = {
            token: this.getToken,
            user_merchant_id: this.$getSessionStorage("userid"),
            shop_id: this.shop_id,
            category_id: this.ids,
            talent_all: talent_all,
          };
          this.categoryAdd(params).then(({ data }) => {
            this.btnload = false;
            if (data.code == 1) {
              this.$message.success("添加成功！");
              this.handleClose();
              this.$emit("init");
            } else {
              this.$message.error(data.msg);
            }
          });
        } else {
          this.$message.warning(`必传资质类目不能为空！`);
        }
      } else {
        let params = {
          token: this.getToken,
          user_merchant_id: this.$getSessionStorage("userid"),
          shop_id: this.shop_id,
          category_id: this.ids,
          talent_all: talent_all,
        };
        this.categoryAdd(params).then(({ data }) => {
          this.btnload = false;
          if (data.code == 1) {
            this.$message.success("添加成功！");
            this.handleClose();
            this.$emit("init");
          } else {
            this.$message.error(data.msg);
          }
        });
      }

    },
    //文件上传
    handleChange (file, fileList, index, talent_id) {
      var formdata = new FormData();
      formdata.append("formdata", file.raw);
      let i;
      switch (index) {
        case 1:
          i = this.CategoryData.findIndex((item) => {
            return talent_id == item.talent_id;
          });
          this.$set(this.CategoryData[i], "file", fileList);
          break;

        default:
          break;
      }
      this.uploadFile(formdata).then((res) => {
        if (res.code == 1) {
          // console.log(res);
          this.$message.success("上传成功！");
          switch (index) {
            case 1:
              this.$set(this.talentList[i], "url", res.data.formdata_details[0].urls);
              break;

            default:
              break;
          }
        } else {
          this.$message({
            type: "warning",
            message: res.msg,
          });
        }
      });
    },
    //文件删除
    handleRemove (file, fileList, index, talent_id) {
      let i;
      switch (index) {
        case 1:
          i = this.CategoryData.findIndex((item) => {
            return talent_id == item.talent_id;
          });
          this.$set(this.talentList[i], "file", []);
          break;
        default:
          break;
      }
    },
    //获取商品分类
    getCategoryList () {
      this.getGoodLei({
        token: this.getToken,
      }).then((res) => {
        if (res.code == 1) {
          this.category_options = res.data.treeData;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //类别筛选
    getItem (list, id) {
      if (!list instanceof Array) {
        return null;
      }
      for (let i in list) {
        let item = list[i];
        if (item.id === id) {
          return item.name;
        } else {
          if (item.children) {
            let value = this.getItem(item.children, id);
            if (value) {
              return value;
            }
          }
        }
      }
    },
    //获取类别信息
    getCategoryManges (ids) {
        this.talentList =[]
      this.categoryLoad = true;
      this.categoryManges({ token: this.getToken, category_id: ids }).then(({ data }) => {
        this.categoryLoad = false;
        if (data.code == 1) {
          if (data.data.category && data.data.category.length > 0) {
            data.data.category.forEach((item) => {
              this.CategoryData.forEach((val, index) => {
                if (item.id == val.three_id) {
                  this.$set(this.CategoryData[index], "deposit", item.deposit);
                }
              });
            });
          }
          if (data.data.talent && data.data.talent.length > 0) {
console.log( data.data.talent,' data.data.talent-------------')
            data.data.talent.forEach((item) => {
                this.talentList.push({
                  is_must: item.is_must,
                  explain: item.explain,
                  category_name: item.category_name,
                  name: item.name,
                  talent_id: item.id,
                });
            });
          }
          this.category_price = 0;
          this.CategoryData.forEach((item) => {
            this.category_price += Number(item.deposit);
          });
          this.total_amount = Number(this.category_price) + Number(this.shop_price);
          this.$forceUpdate();
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    //选择类别数据处理
    selectListFunc (val) {

      if (val.length > 0) {
        val.forEach((it) => {
          this.selectList = this.selectList.filter((item) => {
            return item[2] != it[2];
          });
        });
        this.selectList = [...this.selectList, ...val];
      }
      this.CategoryData = [];
      if (this.selectList.length > 0) {
        this.selectList.forEach((item) => {
          if (item.length == 3) {
            let obj = {
              file: [],
              url: "",
              one_id: item[0],
              two_id: item[1],
              three_id: item[2],
              one: this.getItem(this.category_options, item[0]),
              two: this.getItem(this.category_options, item[1]),
              three: this.getItem(this.category_options, item[2]),
            };
            this.CategoryData.push(obj);
          }
        });
      }

      this.ids = "";
      this.getSpanArr(this.CategoryData, ["one"]);
      this.selectList.forEach((item, index) => {
        if (index == this.selectList.length - 1) {
          this.ids += item[2];
        } else {
          this.ids += item[2] + ",";
        }
      });
      this.getCategoryManges(this.ids);
    },
    //删除类别
    deleteItem (row) {
    //category
      this.category=''
      this.CategoryData = this.CategoryData.filter((item) => row != item);
      this.selectList = this.selectList.filter((item) => row.three_id != item[2]);
      this.getSpanArr(this.CategoryData, ["one"]);
       this.ids = "";
      this.selectList.forEach((item, index) => {
        if (index == this.selectList.length - 1) {
          this.ids += item[2];
        } else {
          this.ids += item[2] + ",";
        }
      });
      console.log(this.ids,'this.ids---', this.selectList)
           this.getCategoryManges(this.ids);
    },
    //表单合并
    cellMerge ({ row, column, rowIndex, columnIndex }) {
      //判断当前单元格是否需要合并
      console
      if (row.mergeCell.includes(column.property)) {
        const rowspan = row[`rowspan_${column.property}`];
        if (rowspan) {
          return { rowspan: rowspan, colspan: 1 };
        } else {
          return { rowspan: 0, colspan: 0 };
        }
      }
    },
    //表单合并
    getSpanArr (data, fieldArr) {
      let lastItem = {};
      fieldArr.forEach((field, index) => {
        data.forEach((item) => {
          item.mergeCell = fieldArr;
          const rowSpan = `rowspan_${field}`;
          //判断是否合并到上个单元格。
          if (fieldArr.slice(0, index + 1).every((e) => lastItem[e] == item[e])) {
            //是：合并行
            item[rowSpan] = 0;
            lastItem[rowSpan] += 1;
          } else {
            //否：完成一次同类合并。lastItem重新赋值，进入下一次合并计算。
            item[rowSpan] = 1;
            lastItem = item;
          }
        });
      });
    },

    handleClose () {
      this.dialogVisible = false;
      this.CategoryData = [];
      this.selectList = [];
      this.ids = "";
      this.categoryLoad = false;
      this.category = [];
      this.shop_id = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  height: 450px;
}
.subtitle {
  margin: 35px 0;
  display: flex;
  align-items: center;
  .el-button {
    margin-left: 40px;
  }
  p {
    line-height: 18px;
    margin-left: 40px;
    span {
      margin-left: 14px;
      color: #ea5846;
    }
  }
  h4 {
    padding-left: 20px;
    line-height: 18px;
    position: relative;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 2px;
      background: #2448ff;
    }
  }
}
</style>